import React, { ReactNode } from 'react';

import { StepDetail } from 'screens/MyJourney/details/StepDetail';
import styled from 'styled-components';

interface Props {
  description: ReactNode;
}

export const StepDescription = ({ description }: Props) => {
  return (
    <StepDetail>
      <FlexContainer>
        <Description>{description}</Description>
      </FlexContainer>
    </StepDetail>
  );
};

const FlexContainer = styled.div`
  display: flex;

  @media ${({ theme }) => theme.queries.minLargeDesktop} {
    flex-wrap: wrap;
  }
`;

const Description = styled.div`
  p {
    margin-top: 20px;
  }
  p:first-of-type {
    margin-top: 0;
  }
`;
